import { IPromise, IHttpService, IRequestShortcutConfig, IQService } from "angular";

import { EnvironmentService } from "@gtmhub/env";
import { IAssignee } from "../models";
import { ICollection } from "../../models";
import { IUIError, createUIError } from "@gtmhub/error-handling";
import { ISocketV2Data } from "@gtmhub/sockets";
import { IRequestAssigneesAction, IReceiveAssigneesAction, IErrorReceiveAssigneesAction, IUpdateAssigneesAction, IUpdateAssigneeAction } from "./models";
import { IAssigneesStoreState } from "./assignee-reducer";
import { getFullCollectionInBatches } from "@gtmhub/util";

const requestAssignees = (): IRequestAssigneesAction => ({ type: "REQUEST_ASSIGNEES" });
const receiveAssignees = (items: IAssignee[]): IReceiveAssigneesAction => ({ type: "RECEIVE_ASSIGNEES", items });
const requestAssigneesError = (error: IUIError): IErrorReceiveAssigneesAction => ({ type: "ERROR_RECEIVE_ASSIGNEES", error });
const updateAssignees = (update: ISocketV2Data<IAssignee>): IUpdateAssigneesAction => ({ type: "UPDATE_ASSIGNEES", update });
const updateAssignee = (assignee: IAssignee): IUpdateAssigneeAction => ({ type: "UPDATE_ASSIGNEE", assignee });
const shouldFetchAssignees = (state: IAssigneesStoreState) => !state.assignees.isFetching && !state.assignees.isFetched;

export class AssigneeActions {
  private initializationPromise = null;

  public static $inject = ["$http", "$q", "EnvironmentService"];

  constructor(private $http: IHttpService, private $q: IQService, private env: EnvironmentService) {}

  public updateAssignee(assignee: IAssignee): (dispatch) => void {
    return (dispatch) => {
      dispatch(updateAssignee(assignee));
    };
  }

  public updateAssignees(update: ISocketV2Data<IAssignee>): (dispatch) => void {
    return (dispatch) => {
      dispatch(updateAssignees(update));
    };
  }

  public getAssignees(): (dispatch, getState) => IPromise<ICollection<IAssignee>> {
    return (dispatch, getState) => {
      if (shouldFetchAssignees(getState())) {
        dispatch(requestAssignees());

        const url = this.env.getApiEndpointV2("/assignees");
        const query: IRequestShortcutConfig = {
          params: { skip: 0, limit: 500 },
        };

        this.initializationPromise = getFullCollectionInBatches<IAssignee>(url, query, this.$http, this.$q).then(
          (response) => dispatch(receiveAssignees(response.items)),
          (rejection) => dispatch(requestAssigneesError(createUIError(rejection)))
        );
      }

      return this.initializationPromise;
    };
  }
}
